import React from "react";

import SubscriptionStats from "./components/SubscriptionStats";
import SubscriptionFilters from "./components/SubscriptionFilters";
import SubscriptionRenewalAlert from "./components/SubscriptionRenewalAlert";
import SubscriptionsTable from "./components/SubscriptionsTable";
import SubscriptionsMobileList from "./components/SubscriptionsMobileList";
import SubscriptionDetailsDrawer from "./components/SubscriptionDetailsDrawer";
import SubscriptionsPagination from "./components/SubscriptionsPagination";
import SubscriptionsSkeleton from "./components/SubscriptionsSkeleton";
import SubscriptionsEmptyState from "./components/SubscriptionsEmptyState";

import useScrollToTop from "../../../hooks/useScollToTop";
import { useAdminSubscriptions } from "./hooks/useAdminSubscriptions";

function SubscriptionsAdmin() {
  useScrollToTop();

  const {
    filteredSubscriptions,
    paginatedSubscriptions,
    filters,
    stats,
    formuleOptions,
    selectedSubscription,
    isDrawerOpen,
    loading,
    refreshing,
    page,
    totalPages,
    fetchSubscriptions,
    updateFilter,
    resetFilters,
    setPage,
    openSubscriptionDrawer,
    closeSubscriptionDrawer,
    handleDeleteSubscription,
  } = useAdminSubscriptions();

  const hasFilters = Boolean(
    filters.search ||
      filters.status ||
      filters.payment ||
      filters.formule,
  );

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <SubscriptionsSkeleton />
      ) : (
        <>
          <SubscriptionStats stats={stats} />

          <SubscriptionRenewalAlert stats={stats} />

          <SubscriptionFilters
            filters={filters}
            formuleOptions={formuleOptions}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchSubscriptions({ silent: false })}
          />

          {paginatedSubscriptions.length > 0 ? (
            <>
              <SubscriptionsTable
                subscriptions={paginatedSubscriptions}
                onOpen={openSubscriptionDrawer}
                onDelete={handleDeleteSubscription}
              />

              <SubscriptionsMobileList
                subscriptions={paginatedSubscriptions}
                onOpen={openSubscriptionDrawer}
                onDelete={handleDeleteSubscription}
              />

              <SubscriptionsPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredSubscriptions.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <SubscriptionsEmptyState
              hasFilters={hasFilters}
              onReset={resetFilters}
            />
          )}

          <SubscriptionDetailsDrawer
            isOpen={isDrawerOpen}
            subscription={selectedSubscription}
            onClose={closeSubscriptionDrawer}
            onDelete={handleDeleteSubscription}
          />
        </>
      )}
    </div>
  );
}

export default SubscriptionsAdmin;